export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.substring(1);
};

export const capitalizeAtFirst = (str: string): string => {
  return str.toLowerCase().split(' ').map(capitalizeFirstLetter).join(' ');
};

export const keepNumbers = (str: string): string => {
  return str.replace(/[^\d]/g, '');
};

export const formatPrice = (value: string): string => {
  if (!value) {
    return value;
  }

  const price = value.replace(/[^\d]/g, '');

  const priceLength = price.length;

  if (priceLength < 4) {
    return price;
  }

  if (priceLength < 7) {
    return `${price.slice(0, -3)},${price.slice(-3)}`;
  }

  return price;
};

export const checkNormalizeString = (str: string): string => {
  // Normalize the string by replacing diacritic characters with their base characters
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Replace multiple spaces with a single space
  str = str.replace(/\s+/g, ' ').trim();

  str = str.replace(/\n|\r/g, '');

  return str;
};

export const formatPhoneNumber = (value: string | undefined) => {
  if (!value) {
    return value;
  }

  const phoneNumber = value.replace(/[^\d]/g, '');

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) {
    return phoneNumber;
  }

  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

/**
 * Normalizes a phone number to digits only for API compatibility
 * Strips all formatting characters and returns just the 10 digits
 * @param value - Phone number in any format
 * @returns 10-digit phone number string or empty string if invalid
 */
export const normalizePhoneNumber = (value: string | undefined): string => {
  if (!value) {
    return '';
  }

  const digits = value.replace(/[^\d]/g, '');

  // If we have 11 digits starting with 1 (US country code), remove the 1
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1);
  }

  // Return only if we have exactly 10 digits
  return digits.length === 10 ? digits : '';
};

export const convertToTestIdFormat = (inputString: string) => {
  const formattedString: string = inputString.toLowerCase().split(' ').join('_');

  return formattedString;
};

export const isEmail = (email: string): boolean => {
  // \w+ matches the part before @, to be at least 1 word
  // @\w{2,} ensures the domain after @ to be at least 2 chars
  // @\w{2,} ensures the TLD after . to be at least 2 chars
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return regex.test(email);
};
